module.exports = __webpack_public_path__ + "static/media/rappi-ecommerce@2x.845eefbe.png";